import { ReactNode, useState } from 'react';
import { PropertyFilters } from '@model';
import {
  PropertyFiltersContext,
  PropertyFiltersModel,
} from './PropertyFiltersContext.ts';

type PropertyFiltersProviderProps = {
  children: ReactNode;
};

export const PropertyFiltersProvider = ({
  children,
}: PropertyFiltersProviderProps) => {
  const [filters, setFilters] = useState(new PropertyFilters());
  const [showModal, setShowModal] = useState(false);

  const model: PropertyFiltersModel = {
    filters: filters,
    isPropertyFiltersModalOpen: showModal,
    hidePropertyFiltersModal: () => setShowModal(false),
    setFilters: setFilters,
    showPropertyFiltersModal: () => setShowModal(true),
  };

  return (
    <PropertyFiltersContext.Provider value={model}>
      {children}
    </PropertyFiltersContext.Provider>
  );
};
